'use client';

import dynamic from 'next/dynamic';
import { Container } from '@weareconceptstudio/core';
import ContactUsTemplateStyle from './style';

const Hero = dynamic(() => import('../components/Hero'), {
	ssr: true,
});
const Map = dynamic(() => import('../components/Map'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '40vh' }} />,
});
const ContactForm = dynamic(() => import('../components/ContactForm'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '40vh' }} />,
});

const ContactUsTemplate = ({ pageData }) => {
	const { content } = pageData;
	const { title, description } = content;

	return (
		<ContactUsTemplateStyle className='contact-us-template'>
			<Container className='contact-us-template-container'>
				<div className='empty-block col-1 col-ds-12' />

				<div className='content-block col-10 col-ds-12'>
					<div className='content-inner-block'>
						<Hero
							title={title}
							description={description}
						/>

						<ContactForm />

						<Map />
					</div>
				</div>

				<div className='empty-block col-1 col-ds-12' />
			</Container>
		</ContactUsTemplateStyle>
	);
};

export default ContactUsTemplate;
